"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toSfdcValue = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _BETActivityTypes = require("crm_ui/constants/BETActivityTypes");

var _ref;

var sfdcValueMap = new _immutable.Map((_ref = {}, (0, _defineProperty2.default)(_ref, _BETActivityTypes.CALL, 'Call'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.CALL_NO_VOICEMAIL, 'Call No Voicemail'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.DEMO, 'Demo'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.DISCOVERY, 'Discovery Call'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.EMAIL, 'Email'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.GOAL_SETTING, 'Goal Setting'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.IMA, 'IMA'), (0, _defineProperty2.default)(_ref, _BETActivityTypes.VOICEMAIL, 'VMail'), _ref));

var toSfdcValue = function toSfdcValue(activityType) {
  return sfdcValueMap.has(activityType) ? sfdcValueMap.get(activityType) : activityType;
};

exports.toSfdcValue = toSfdcValue;